var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "0 0 150 52.499999",
    height: 70,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d037e86d6b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.949219 6.652344 L 110.835938 6.652344 L 110.835938 42.800781 L 1.949219 42.800781 Z M 1.949219 6.652344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8fb0385e7d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 39.238281 6.757812 L 148.128906 6.757812 L 148.128906 42.910156 L 39.238281 42.910156 Z M 39.238281 6.757812 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d037e86d6b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9f9f",
    d: "M 56.390625 6.398438 L 38.363281 24.40625 L 1.996094 -11.917969 L 1.996094 6.472656 L 38.363281 42.800781 L 56.390625 24.789062 L 74.421875 42.800781 L 110.789062 6.472656 L 110.789062 -11.917969 L 74.421875 24.40625 L 56.390625 6.398438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8fb0385e7d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e97777",
    d: "M 93.683594 43.160156 L 111.714844 25.152344 L 148.082031 61.476562 L 148.082031 43.085938 L 111.714844 6.757812 L 93.683594 24.769531 L 75.652344 6.757812 L 39.285156 43.085938 L 39.285156 61.476562 L 75.652344 25.152344 L 93.683594 43.160156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.cad7388da576b8a752a0ac2868a9f8a3.svg";
export { ForwardRef as ReactComponent };